import { Component, Input, EventEmitter, Output, HostListener } from '@angular/core';
import { ArtWorkInterface } from "../../utils/interfaces/art-work.interface";

@Component({
  selector: 'app-image-modal',
  standalone: true,
  imports: [],
  templateUrl: './image-modal.component.html',
  styleUrl: './image-modal.component.scss'
})
export class ImageModalComponent {
  @Input() work: ArtWorkInterface | null = null;
  @Output() close = new EventEmitter<void>();

  onClose(): void {
    this.close.emit();
  }

  @HostListener("document:keydown", ["$event"])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (event.key === "Escape" || event.key === "Backspace") {
      this.onClose();
    }
  }
}
